import(/* webpackMode: "eager" */ "/app/src/app/(web)/bors/kalender/page.tsx");
